import type { StateCreator } from "zustand";
import { REALMS } from "@/constants/process";

export interface RealmSliceState {
  realm: "evbasic" | "evcore" | undefined;
}

interface RealmSliceActions {
  setRealm: (
    nextRealm:
      | RealmSliceState["realm"]
      | ((currentRealm: RealmSliceState["realm"]) => RealmSliceState["realm"])
  ) => void;
}

export type RealmSlice = RealmSliceState & RealmSliceActions;

export const createRealmSlice: StateCreator<
  RealmSlice,
  [["zustand/devtools", never]],
  [],
  RealmSlice
> = (set) => ({
  realm: REALMS.EVCORE as RealmSliceState["realm"],
  setRealm: (nextRealm) =>
    set((state) => ({
      realm: typeof nextRealm === "function" ? nextRealm(state.realm) : nextRealm,
    })),
});
